<template>
  <!-- «Условия сейчас»: последние показания ближайшей метеостанции. -->
  <div class="flex flex-wrap items-center gap-1.5" data-conditions-now>
    <AlertChip
      tone="info"
      :icon="Thermometer"
      :label="summary"
      :hint="$t('routeDetails.conditionsNow', { name: conditions.nodeName, km: conditions.km.toFixed(0) })"
    />
    <AlertChip
      v-for="alert in conditions.alerts"
      :key="alert"
      :tone="alert === 'windStrong' ? 'danger' : 'warn'"
      :label="$t(`live.stationDetail.alerts.${alert}`)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Thermometer } from "lucide-vue-next";
import AlertChip from "../ui/AlertChip.vue";
import type { ConditionsNow } from "../../composables/useConditionsNow";

const props = defineProps<{ conditions: ConditionsNow }>();
const { t } = useI18n();

const summary = computed(() => {
  const parts = [t("routeDetails.conditionsNow", { name: props.conditions.nodeName, km: props.conditions.km.toFixed(0) })];
  if (props.conditions.tempC != null) parts.push(`${props.conditions.tempC.toFixed(1)}°C`);
  if (props.conditions.windMs != null) parts.push(`${props.conditions.windMs.toFixed(1)} ${t("units.ms")}`);
  return parts.join(" · ");
});
</script>
